import React from 'react';
import Migration from '../components/Migration';
import Contact from '../components/Contact';
import '../styles/Migration.css';

const MigrationPage: React.FC = () => {
  return (
    <>
      <Migration />
      <Contact />
    </>
  );
};

export default MigrationPage;
